import React from "react";
import { Artefact, CitationInfo, type FileItem, type FolderItem } from "@/modules/chat/chat-ui.types";
import type { SidePanelTab } from "@/components/chat/types";

export type RightDrawerContentType = "artefacts" | "pdf" | "promptGenerator" | "settings" | "promptLibrary" | null;

export interface CurrentPdfContextType {
  activeTab: SidePanelTab | null;
  setActiveTab: (tab: SidePanelTab | null) => void;
  currentPdfId: string | null;
  setCurrentPdfId: (id: string | null) => void;
  isRightDrawerVisible: boolean;
  setIsRightDrawerVisible: (visible: boolean) => void;
  rightDrawerContent: RightDrawerContentType;
  setRightDrawerContent: (content: RightDrawerContentType) => void;
  handleCitationClick: (citation: CitationInfo) => void;
  currentCitation: CitationInfo | null;
  setCurrentCitation: (citation: CitationInfo | null) => void;
  handleFileSelect: (file: FileItem, isSelected: boolean) => void;
  setSelectedFiles: (files: string[]) => void;
  selectedFiles: string[];
  setRootItem: (item: FolderItem | FileItem) => void;
  rootItem: FolderItem | FileItem | undefined;
  setArtefacts: (artefacts: Artefact[]) => void;
  setSelectedArtefactId: (artefactId: string | null) => void;
  selectedArtefactId: string | null;
  artefacts: Artefact[];
}

export const CurrentPdfContext = React.createContext<CurrentPdfContextType | undefined>(undefined);
